import { CheckCircle2, Circle, Eye, EyeOff, KeyRound } from "lucide-react";

export const getPasswordChecks = (password, confirmPassword = "", includeMatchCheck = false) => {
  const checks = [
    { label: "Au moins 10 caracteres", valid: password.length >= 10 },
    { label: "Une majuscule", valid: /[A-Z]/.test(password) },
    { label: "Une minuscule", valid: /[a-z]/.test(password) },
    { label: "Un chiffre", valid: /\d/.test(password) },
  ];

  if (includeMatchCheck) {
    checks.push({
      label: "Les deux mots de passe sont identiques",
      valid: Boolean(password) && Boolean(confirmPassword) && password === confirmPassword,
    });
  }

  return checks;
};

export const getPasswordStrength = (password, confirmPassword = "", includeMatchCheck = false) => {
  const checks = getPasswordChecks(password, confirmPassword, includeMatchCheck);
  const passed = checks.filter((item) => item.valid).length;

  if (!password) return { label: "À compléter", tone: "neutral", checks };
  if (passed === checks.length) return { label: "Mot de passe acceptable", tone: "success", checks };
  if (passed >= 2) return { label: "Presque bon", tone: "warning", checks };
  return { label: "Trop faible", tone: "danger", checks };
};

export function PasswordRequirements({ password, confirmPassword = "", showMatchCheck = false }) {
  const strength = getPasswordStrength(password, confirmPassword, showMatchCheck);

  return (
    <div className="support-password-box">
      <div className={`support-password-status is-${strength.tone}`}>
        <KeyRound className="w-4 h-4" />
        {strength.label}
      </div>
      <div className="support-password-rules">
        {strength.checks.map((check) => (
          <div key={check.label} className={`support-password-rule ${check.valid ? "is-valid" : ""}`}>
            {check.valid ? <CheckCircle2 className="w-4 h-4" /> : <Circle className="w-4 h-4" />}
            <span>{check.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function PasswordField({
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  isVisible,
  onToggleVisibility,
}) {
  return (
    <div className="support-password-input-wrap">
      <input
        className="form-input support-password-input"
        type={isVisible ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
      />
      <button
        type="button"
        className="support-password-toggle"
        onClick={onToggleVisibility}
        aria-label={isVisible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        aria-pressed={isVisible}
      >
        {isVisible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
        <span>{isVisible ? "Masquer" : "Afficher"}</span>
      </button>
    </div>
  );
}
